import React from "react";
import "./HomeScreen.css";
import { NavigatorWrapper } from "components/reusable/NavigatorWrapper";
import { navigateToNew } from "utilities/js/NavigationHelper";
import { freezeBody, unfreezeBody } from "utilities/js/styling/domUtilities";
import {getRecentCreateBrackets} from "../../utilities/js/localstorage/StorageHelper_CreateBrackets";
import {getRecentViewBrackets} from "../../utilities/js/localstorage/StorageHelper_ViewBrackets";
import ViewBracketOpener from "components/reusable/ViewBracketOpener";
import Panel from "../../components/reusable/Panel";
import HomeSearchContainer from "components/search/HomeSearchContainer";
import DraftPrompt from "components/reusable/DraftPrompt";
import PopupPrompt from "pages/create/PopupPrompt";
import { getBracketDraft, setBracketDraft } from "utilities/js/localstorage/StorageHelper_BracketDraft";
import Constants from "utilities/js/Constants";

const LogoIcon = Constants.ICON_LOGO_THEME;

class HomeScreen extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            displayViewPanel: false,
            displayCreatePanel: false,
            createId: '',
            viewId: '',
            bracketsToUpdate: getRecentCreateBrackets(),
            bracketsToView: getRecentViewBrackets(), //Temp: Read bracketsToUpdate from storageManager
            isCreateWarningVisible: false
        };


        this.openCreatePanel = this.openCreatePanel.bind(this);
        this.openViewPanel = this.openViewPanel.bind(this);
        this.closeViewPanel = this.closeViewPanel.bind(this);
        this.closeCreatePanel = this.closeCreatePanel.bind(this);
        this.navigateToDraft = this.navigateToDraft.bind(this);
        this.navigateToNew = this.navigateToNew.bind(this);
        this.tryNavigateToNew = this.tryNavigateToNew.bind(this);
        this.closeCreateWarning = this.closeCreateWarning.bind(this);

    }

    tryNavigateToNew(){
        if(getBracketDraft()){
            freezeBody();
            this.setState({isCreateWarningVisible: true});
        }else{
            navigateToNew({routerNav: this.props.navigate});
        }
    }

    navigateToNew(){
        setBracketDraft(null);
        unfreezeBody();
        navigateToNew({routerNav: this.props.navigate});
    }
    navigateToDraft(){
        navigateToNew({routerNav: this.props.navigate});
    }

    closeCreateWarning(event){
        this.setState({isCreateWarningVisible: false});
        event.stopPropagation();
        unfreezeBody();
    }
    
    openViewPanel(){
        //open modal with recent brackets you've viewed
        this.setState({displayViewPanel: true});
        freezeBody();
    }

    openCreatePanel(){
        //open modal with most recent brackets you've created
        this.setState({displayCreatePanel: true});
        freezeBody();
    }

    closeViewPanel(){
        //open modal with recent modals you've viewed
        this.setState({displayViewPanel: false});
        unfreezeBody();
    }

    closeCreatePanel(){
        //open modal with recent brackets you've viewed
        this.setState({displayCreatePanel: false});
        unfreezeBody();
    }

    render(){
    
        return (
            <>
                <div className="hide-mobile">
                    <HomeSearchContainer></HomeSearchContainer>
                </div>
                <DraftPrompt></DraftPrompt>
                <div className="home-nav-launcher nav-panel">
                    <div className="logo-container"><img className="home-nav-bracket-logo" alt="bracket-logo" src={LogoIcon}/> </div>
                    <div className="home-nav-page-masthead">Brackset</div>
                    <div className="landing-page-tagline">The worldwide leader in bracket generation</div>
                    <div className="landing-nav-buttons">
                        <div className="nav-button-container view"><button className="nav-button" onClick={this.openViewPanel}>View</button></div>
                        <div className="nav-button-container update"><button className="nav-button" onClick={this.tryNavigateToNew}>Create</button></div>
                    </div>
                </div>     


                <Panel shouldDisplay={this.state.displayViewPanel} headerText="View Brackets" closePanel={this.closeViewPanel} showClose="true">
                    <ViewBracketOpener bracketsToView={this.state.bracketsToView}></ViewBracketOpener>
                </Panel>
                <Panel shouldDisplay={this.state.isCreateWarningVisible} headerText="Replace Draft" closePanel={this.closeCreateWarning} showClose="true" hideFooter="true">
                    <div className="create-warning-content">
                        <div className="create-warning-text">
                            Creating a new bracket will replace any existing drafts that have been started
                        </div>
                        <div className="create-warning-buttons">
                            <button className="nav-button h-button" onClick={this.navigateToDraft}>Resume Draft</button>
                            <button className="nav-button nav-button-green h-button" onClick={this.navigateToNew}>New Bracket</button>
                        </div>
                    </div>
                </Panel>

                {/* <PopupPrompt header="Replace Draft" isVisible={this.state.isCreateWarningVisible} closeLabel="Cancel" closePanel={this.closeCreateWarning}>
                    
                </PopupPrompt> */}
            </>
            
        );
    }
}

export default NavigatorWrapper(HomeScreen);
